import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import OfflineBanner from "@/components/OfflineBanner";

const variants = {
  initial:  { opacity: 0, y: 12 },
  animate:  { opacity: 1, y: 0, transition: { duration: 0.22, ease: [0.4, 0, 0.2, 1] } },
  exit:     { opacity: 0, y: -8, transition: { duration: 0.15, ease: [0.4, 0, 1, 1] } },
};

export default function AppShell({ children, className = "" }) {
  const { pathname } = useLocation();
  return (
    <div className={`min-h-screen bg-[var(--bg)] text-[var(--text)] ${className}`}>
      <OfflineBanner />
      <AnimatePresence mode="wait">
        <motion.div
          key={pathname}
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          className="relative z-10 max-w-2xl mx-auto pb-24 safe-top"
        >
          {children}
        </motion.div>
      </AnimatePresence>
      <BottomNav />
    </div>
  );
}
